import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { ButtonBar, ScreenHeader } from '../../components';

export function NewHDSummaryScreen({ isContinue }) {
  const navigate = useNavigate();
  
  const handleCancel = useCallback(() => {
    navigate('/home');
  }, [ navigate ]);

  const handleNext = useCallback(() => {
    navigate('../pregnancy-status');
  }, [ navigate ]);

  const subtitle = isContinue ? 'Continue from where you left off...' : 'Review your choices';

  return (
    <div className="new-fa-intro-screen screen-container">
      <ScreenHeader
        title="Summary"
        description={subtitle}
      />
      <ButtonBar 
        handlePrimary={handleNext}
        handleSecondary={handleCancel}
        primaryText="Get Started"
        secondaryText="Cancel"
      />
    </div>
  );
}